(function() {
    const onDealerInfoModalTriggerClick = (event) => {
        const modalTrigger = event.target.closest('modal-trigger[modal-id*="modal-dealer-info-"]');

        if (!modalTrigger) {
            return;
        }

        const modalId = modalTrigger.getAttribute('modal-id');
        const locationName = modalTrigger.getAttribute('data-dealer-name');

        if (!modalId || !locationName) {
            return;
        }

        const modal = document.querySelector(`modal-overlay#${modalId}`);

        if (!modal) {
            return;
        }

        const modalTitle = modal.querySelector('.op-modal-dealer-info h3');

        if (!modalTitle) {
            return;
        }

        modalTitle.innerText = locationName;

        setLocationAddress(modal, locationName);
        setContactButtonHref(modal, modalTrigger);
    };

    const setLocationAddress = (modal, locationName) => {
        let addressObject;

        switch (locationName) {
            case 'Welzorg Auto op Maat Den Bosch':
                addressObject = {
                    street: 'Rietveldenweg 51',
                    city: '\'s-Hertogenbosch',
                    postalCode: '5222 AP',
                };
                break;
            case 'Welzorg Auto op Maat Spijkenisse':
                addressObject = {
                    street: 'Boyleweg 4',
                    city: 'Spijkenisse',
                    postalCode: '3208 KA',
                };
                break;
            case 'Welzorg Auto op Maat Zwolle':
                addressObject = {
                    street: 'Nipkowstraat 1B',
                    city: 'Zwolle',
                    postalCode: '8013 RJ',
                };
                break;
            default:
                addressObject = null;
        }

        if (!addressObject) {
            return;
        }

        const modalStreet = modal.querySelector('.op-modal-dealer-info__col__street');
        const modalPostalCodeAndCity = modal.querySelector('.op-modal-dealer-info__col__postal-code-and-city');

        if (!modalStreet || !modalPostalCodeAndCity) {
            return;
        }

        modalStreet.innerText = addressObject.street;
        modalPostalCodeAndCity.innerText = `${addressObject.postalCode} ${addressObject.city}`;
    };

    const setContactButtonHref = (modal, modalTrigger) => {
        const metaDiv = modalTrigger.closest('.op-meta');

        if (!metaDiv) {
            return;
        }

        const contactButton = metaDiv.querySelector('.btn--secondary.btn--block');
        const contactLink = modal.querySelector('.contact-link');

        if (!contactButton || !contactLink) {
            return;
        }

        contactLink.href = contactButton.href;
    };

    const dealerInfoModalTriggers = document.querySelectorAll('modal-trigger[modal-id*="modal-dealer-info-"]');

    dealerInfoModalTriggers.forEach(modalTrigger => {
        modalTrigger.addEventListener('click', onDealerInfoModalTriggerClick);
        modalTrigger.addEventListener('touchend', onDealerInfoModalTriggerClick);
    });
}());


// WEBPACK FOOTER //
// ./scripts/custom/occasion-dealer-info-modal.js